import { render, staticRenderFns } from "./ForgotPasswordEmail.vue?vue&type=template&id=c13c51dc&scoped=true"
import script from "./ForgotPasswordEmail.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordEmail.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordEmail.vue?vue&type=style&index=0&id=c13c51dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13c51dc",
  null
  
)

export default component.exports